import i18n from '@/i18n';
import {ResidentStatus} from '@/services/graphqlHooks';

const residentStatuses = {
  [ResidentStatus.Pending]: i18n.t('Pending'),
  [ResidentStatus.Active]: i18n.t('Active'),
  [ResidentStatus.Absent]: i18n.t('Absent'),
  [ResidentStatus.Deactivated]: i18n.t('Deactivated'),
} as Record<ResidentStatus, string>;

export default residentStatuses;
